export default __webpack_public_path__ + "static/media/dd3.7ecb0ae4.jpg";